<template>
  <div>{{ item.name }}</div>
</template>

<script>
export default {
  props: {
    item: { required: true }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AutocompleteItem.vue